import { render } from "./BonoBannerStripe.vue?vue&type=template&id=33ff1e62&scoped=true"
import script from "./BonoBannerStripe.vue?vue&type=script&lang=js"
export * from "./BonoBannerStripe.vue?vue&type=script&lang=js"

import "./BonoBannerStripe.vue?vue&type=style&index=0&id=33ff1e62&scoped=true&lang=css"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ff1e62"]])

export default __exports__